import gql from 'graphql-tag'

import { GatheringFieldsFragment } from 'main/gql/gathering'
import { SchoolFieldsFragment, SchoolWithProfileFieldsFragment } from 'main/gql/school'

export const SCHOOL_MAP_CALLOUT_QUERY = gql`
  query SchoolMapCallout($schoolId: Int!) {
    school(id: $schoolId) {
      ...SchoolFields
      ...SchoolWithProfileFields
      upcomingGatherings {
        ...GatheringFields
      }
      aggregateRatings {
        count
        overall
      }
    }
  }

  ${GatheringFieldsFragment}
  ${SchoolFieldsFragment}
  ${SchoolWithProfileFieldsFragment}
`
